

export const redirectionConstants = {
    UPDATE_REDIRECTION_URL: 'UPDATE_REDIRECT_URL',
};
